import React from 'react';
import { Zoom, Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

export default function Wrong(props) {

    const {t} = useTranslation()

    const navigate = useNavigate();

    return (
        <Box>
            <Zoom in color="error" style={{ transitionDelay: 500 }} >
                <Box sx={{margin: 2}}>
                    <Typography color="error">{t("welcomeQuizText2")}</Typography>
                </Box>
            </Zoom>
            <Zoom in style={{ transitionDelay: 1000 }} >
                <Box>
                    <Box sx={{width: "100%", marginBottom: 1}}>
                        <Button size="small"
                            onClick={props.unanswer} variant="contained" color="secondary"
                        >
                            {t("welcomeQuizButton1")}
                        </Button>
                    </Box>
                    <Box sx={{width: "100%"}}>
                        <Button size="small"
                            onClick={() => navigate("/learning")} variant="contained" color="primary"
                        >
                            {t("welcomeQuizButton2")}
                        </Button>
                    </Box>
                </Box>
            </Zoom>
        </Box>
    )
}